import { IonButton, isPlatform } from '@ionic/react';
import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper.min.css';

import img_1 from '../../../assets/InitialSlides/s1.webp';
import img_2 from '../../../assets/InitialSlides/s2.webp';
import img_3 from '../../../assets/InitialSlides/s3.webp';
import { useImageLoad } from '../../../hooks/Utils/useImageLoad';
import { useDynamicTheme } from '../../../theme/useDynamicTheme';
import Button from '../../UI/Button';
import Skeleton from '../../UI/Skeleton';
import './InitialSlides.scss';
import { InitialSlidesProps } from './types';

const InitialSlides: React.FC<InitialSlidesProps> = ({ onClose }) => {
  const swiperRef = useRef<any>(null);
  const { theme } = useDynamicTheme();
  const [activeIndex, setActiveIndex] = useState(0);

  const image1 = useImageLoad(img_1);
  const image2 = useImageLoad(img_2);
  const image3 = useImageLoad(img_3);

  const slidesData = [
    {
      img: img_1,
      imageHook: image1,
      content: (
        <>
          <p>¡Bienvenido a {theme?.brandName}!</p>
          <div>
            La app que te acompaña en cada momento de la vida de tu mascota. Controlá
            vacunas, revisiones y tratamientos, y organizá de forma simple todo el cuidado
            para que tu compañero esté siempre saludable.
          </div>
        </>
      ),
    },
    {
      img: img_2,
      imageHook: image2,
      content: (
        <>
          <p>Cuando más lo necesita</p>
          <div>
            Aunque el cuidado diario es clave, pueden aparecer situaciones inesperadas.{' '}
            {theme?.brandName} te brinda protección integral cubriendo consultas,
            estudios, cirugías y otros gastos para que tu mascota esté siempre protegida.
          </div>
        </>
      ),
    },
    {
      img: img_3,
      imageHook: image3,
      content: (
        <>
          <p>Gestioná tus reintegros</p>
          <div>
            Subí la documentación, seguí el estado de cada solicitud y mantené el contacto
            con tu veterinario desde la app, para que tus reintegros sean rápidos, simples
            y sin complicaciones.
          </div>
        </>
      ),
    },
  ];

  const isLastSlide = activeIndex === slidesData.length - 1;

  const handleNext = () => {
    if (!swiperRef.current) return;
    if (isLastSlide) {
      onClose();
    } else {
      swiperRef.current.slideNext();
    }
  };

  const handleBulletClick = (index: number) => {
    swiperRef.current?.slideTo(index);
  };

  return (
    <div className="initial-slides">
      <div className="initial-slides__top-bar">
        {!isPlatform('ios') && (
          <IonButton fill="clear" onClick={onClose}>
            Saltar
          </IonButton>
        )}
      </div>

      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
      >
        {slidesData.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="initial-slides__slide">
              <div className="initial-slides__content">{slide.content}</div>

              <div className="initial-slides__image-container">
                {!slide.imageHook.imageLoaded && <Skeleton height="100%" />}
                <img
                  src={slide.img}
                  alt={`Slide ${index + 1}`}
                  onLoad={slide.imageHook.handleImageLoad}
                  style={{
                    opacity: slide.imageHook.imageLoaded ? 1 : 0,
                    transition: 'opacity 0.3s ease-in-out',
                  }}
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="initial-slides__bottom">
        <div className="custom-pagination">
          {slidesData.map((_, index) => (
            <span
              key={index}
              className={`bullet ${activeIndex === index ? 'bullet--active' : ''}`}
              onClick={() => handleBulletClick(index)}
            />
          ))}
        </div>
        <Button onClick={handleNext}>{isLastSlide ? 'Comenzar' : 'Siguiente'}</Button>
      </div>
    </div>
  );
};

export default React.memo(InitialSlides);
